



















import {
  defineComponent,
  getCurrentInstance,
  ComponentInternalInstance,
  computed,
  onUnmounted,
} from '@vue/composition-api';

import Login from '@/renderer/components/login/components/index.vue';
import LoginAnimation from '@/renderer/components/login/components/loginAnimation.vue';

import i18n, { i18n_t } from '@/locales/i18n';
import user, { User } from '@/renderer/scripts/utils/user';
import tips from '@/renderer/scripts/utils/tips';
import { getUrlQuery, decodeText } from '@/renderer/scripts/utils/tools/index';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { CONSTANT_URL } from '@/renderer/scripts/http';
export default defineComponent({
  components: {
    Login,
    LoginAnimation,
  },
  setup(props, context) {
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const route = vm.$route;
    const store = vm.$store;
    const { query } = route;
    const showInPc = computed(() => !store.getters.isMobile && !store.getters.isMobileStyle);
    user.setAuthCode(query.auth_code as string);
    user.setLoginAction(User.LoginActionKey.bindPhone);
    user.setLoginBindType(User.LoginBindTypeKey.bindPhoneInMeeting);
    const methods = {
      async logined({ loginPath }: { loginPath: string }) {
        let loginToPath = loginPath || '';
        if (query.login_path) {
          // 授权来的path，需要decodeURIComponent两次，再解密一次
          loginToPath = decodeText(decodeURIComponent(decodeURIComponent(query.login_path as string)));
        }
        if (loginToPath && loginToPath !== '/login') {
          const { url, query: queryObj } = getUrlQuery(loginToPath as string);
          dispatchRouter(
            {
              path: url,
              query: queryObj,
            },
            'replace',
          );
        } else {
          let routerName = vm.$store.getters.isMobileStyle ? 'recentUse' : 'workbench';
          // 若登录时企业已过期自动跳转至过期页面
          if (store.getters.orgExpired) {
            routerName = 'teamExpired';
          }
          dispatchRouter(
            {
              name: routerName,
            },
            'replace',
          );
        }
        let timer: any = setTimeout(() => {
          store.commit('setLoginingMask', false);
          clearTimeout(timer);
          timer = null;
        }, 500);
        tips.success(i18n_t('登录成功'));
      },
      // 前往cofile官网
      goCoFileIndex(target = '_self') {
        dispatchRouter(CONSTANT_URL.officialWebsiteUrl, target);
      },
    };
    user.on('logined', methods.logined);
    onUnmounted(() => {
      user.off('logined', '*');
    });
    return {
      showInPc,
      ...methods,
    };
  },
});
